 export enum InvitationStatus {
    Accepted = "Accepted",
    Rejected = "Rejected",
    Canceled = "Canceled",
    Open = "Open"
}
